<template>
  <v-menu :offset-y="true" class="mt-4">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="ml-2"
        :class="{ black50: greydOut }"
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list
      dense
      class="dropdown-list pa-4"
      style="
        border: thin solid rgba(255, 255, 255, 0.5);
        border-radius: 16px;
        background-color: #1a1a1a;
      "
      :max-width="width"
      :max-height="height"
      outlined
    >
      <v-list-item
        class="menu-item pa-0"
        style="min-height: 32px"
        v-for="(item, index) in items"
        :key="index"
        link
        :inactive="item.button"
        :ripple="!item.button"
      >
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list-item-content class="ma-0 pl-4 pr-4 pa-0">
              <v-list-item-title
                @click="!item.button && emitValue(item.value || item)"
                class="ma-0 pa-0"
              >
                <v-row class="ma-0 pa-0" no-gutters align="center">
                  <niko-button
                    class="mt-4"
                    v-if="item.button"
                    :text="item.value"
                    @onClick="emitValue(item.value || item)"
                    primary
                    width="176px"
                  />
                  <p
                    v-else
                    class="mt-1 smaller"
                    :class="{ 'text-red-darker': item.warning }"
                  >
                    {{ item.value || item }}
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col v-if="!item.button" class="ma-0 mt-1 pa-0 pl-4 pr-4" cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import NikoButton from "./NikoButton";

export default {
  name: "niko-container-dropdown",
  components: {
    NikoButton,
  },
  props: {
    name: String,
    project: Object,
    items: Array,
    width: String,
    height: String,
    greydOut: Boolean,
  },
  methods: {
    emitValue(value) {
      const data = { name: this.name, value: value, project: this.project };
      this.$emit("clicked", data);
    },
  },
};
</script>
